import React, { useEffect, /* useMemo, */ useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from 'swiper/modules';
import { ParticipantList, Ranking } from '../list';

// Tipos mínimos para props (ajusta si tienes tipos reales)
type RankingsForBlock = Record<number, Record<number, any[]>>; // intensityId -> ratingTypeId -> items[]

interface BlockPanel3Props {
  boxId: number;
  date: string; // 'YYYY-MM-DD'
  time: string; // 'HH:mm:ss'
  showBlocks: boolean;
  idBlockActive: number;
  currentBlockId: number;
  getAgentCategory: () => number[] | undefined;
  getIntensityCategoryName: (intensityCategoryId: number) => string | undefined;
  rankingsForCurrentBlock: RankingsForBlock;
  onEmpty?: () => void;
}

const BlockPanel3: React.FC<BlockPanel3Props> = ({
  boxId,
  date,
  time,
  showBlocks,
  idBlockActive,
  currentBlockId,
  getAgentCategory,
  getIntensityCategoryName,
  rankingsForCurrentBlock,
  onEmpty,
}) => {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    setHidden(false);
  }, [boxId, date, time, currentBlockId, rankingsForCurrentBlock, showBlocks]);

  // función para ocultar localmente y notificar al padre
  const hideAndNotify = () => {
    setHidden(true);
    if (onEmpty) onEmpty();
  };
  // Transform to an iterable array to preserve predictable ordering
  /* const rankingEntries = useMemo(() => {
    // Convert Record -> array of [intensityId, Record<ratingTypeId, items[]>]
    return Object.entries(rankingsForCurrentBlock || {}).map(([intStr, byRating]) => ({
      intensityId: Number(intStr),
      byRating,
    }));
  }, [rankingsForCurrentBlock]); */

  /* const renderRankingBlock = (intensityId: number, rtId: number, items: any[]) => {
    const intName = getIntensityCategoryName(intensityId) ?? `Int ${intensityId}`;
    const keyBase = `${currentBlockId}-${intensityId}-${rtId}`;

    if (items.length > 1) {
      return (
        <Swiper
          modules={[Autoplay, EffectFade]}
          autoplay={{ delay: 10000, disableOnInteraction: true }}
          loop
          effect="fade"
          fadeEffect={{ crossFade: true }}
          key={keyBase}
          slidesPerView={1}
          pagination={{ clickable: true } as any}
        >
          {items.map((item, idx) => (
            <SwiperSlide key={`${keyBase}-slide-${idx}`}>
              <div className="w-full mb-5">
                <Ranking
                  title={intName}
                  items={items}
                  blockId={currentBlockId}
                  intensityCategoryId={intensityId}
                  ratingTypeId={rtId}
                  onEmpty={() => {
                    hideAndNotify();
                    hideAndNotify();
                  }}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      );
    }

    return (
      <Ranking
        key={keyBase}
        title={intName}
        items={items}
        blockId={currentBlockId}
        intensityCategoryId={intensityId}
        ratingTypeId={rtId}
        onEmpty={() => {
          hideAndNotify();
        }}
      />
    );
  }; */

  if (hidden) return null;

  return (
    <div className="pt-4 min-w-[0] flex-1 bg-transparent rounded-[24px] overflow-y-auto gap-6">
      {/* Participant list (solo cuando showBlocks true) */}
      <>
        {showBlocks ? (
          <>
            <ParticipantList
              boxId={boxId}
              date={date}
              time={time}
              schedule={getAgentCategory()}
              onEmpty={() => {
                hideAndNotify();
                // aquí puedes, p.ej., ocultar el panel o cambiar un estado
              }}
            />
            <>
              <div className="py-4">
                {Object.entries(rankingsForCurrentBlock).flatMap(([intStr, byRating]) =>
                  Object.entries(byRating).map(([rtStr, items]) => {
                    const intId = Number(intStr);
                    const rtId = Number(rtStr);
                    const intName = getIntensityCategoryName(intId) ?? `Int ${intId}`;
                    return idBlockActive === currentBlockId ? (
                      // Si hay más de 1 ítem, mostrar carrusel swipe
                      items.length > 1 ? (
                        <Swiper
                          modules={[Autoplay, EffectFade]}
                          autoplay={{ delay: 10000, disableOnInteraction: true }}
                          loop
                          effect="fade"
                          fadeEffect={{ crossFade: true }}
                          key={`${currentBlockId}-${intId}-${rtId}`}
                          slidesPerView={1}
                          pagination={{ clickable: true }}
                        >
                          {items.map((item, idx) => (
                            <SwiperSlide key={idx}>
                              <div className="w-full mb-5">
                                <Ranking
                                  title={intName}
                                  // items={[item]}
                                  items={items}
                                  blockId={currentBlockId}
                                  intensityCategoryId={intId}
                                  ratingTypeId={rtId}
                                  onEmpty={() => {
                                    hideAndNotify();
                                    // aquí puedes, p.ej., ocultar el panel o cambiar un estado
                                  }}
                                />
                              </div>
                            </SwiperSlide>
                          ))}
                        </Swiper>
                      ) : (
                        // Si solo uno, render normal
                        <Ranking
                          key={`${currentBlockId}-${intId}-${rtId}`}
                          title={intName}
                          items={items}
                          blockId={currentBlockId}
                          intensityCategoryId={intId}
                          ratingTypeId={rtId}
                          onEmpty={() => {
                            hideAndNotify();
                            // aquí puedes, p.ej., ocultar el panel o cambiar un estado
                          }}
                        />
                      )
                    ) : null; // caso para mostrar cuando no exista bloque activo o ranking
                  }),
                )}
              </div>
            </>
          </>
        ) : (
          <>
            {Object.entries(rankingsForCurrentBlock).flatMap(([intStr, byRating]) =>
              Object.entries(byRating).map(([rtStr, items]) => {
                const intId = Number(intStr);
                const rtId = Number(rtStr);
                const intName = getIntensityCategoryName(intId) ?? `Int ${intId}`;

                return idBlockActive === currentBlockId ? (
                  // Si hay más de 1 ítem, mostrar carrusel swipe
                  items.length > 1 ? (
                    <Swiper
                      modules={[Autoplay, EffectFade]}
                      autoplay={{ delay: 10000, disableOnInteraction: true }}
                      loop
                      effect="fade"
                      fadeEffect={{ crossFade: true }}
                      key={`${currentBlockId}-${intId}-${rtId}`}
                      slidesPerView={1}
                      pagination={{ clickable: true }}
                    >
                      {items.map((item, idx) => (
                        <SwiperSlide key={idx}>
                          <div className="w-full mb-5">
                            <Ranking
                              title={intName}
                              // items={[item]}
                              items={items}
                              blockId={currentBlockId}
                              intensityCategoryId={intId}
                              ratingTypeId={rtId}
                              onEmpty={() => {
                                hideAndNotify();
                                // aquí puedes, p.ej., ocultar el panel o cambiar un estado
                              }}
                            />
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  ) : (
                    // Si solo uno, render normal
                    <Ranking
                      key={`${currentBlockId}-${intId}-${rtId}`}
                      title={intName}
                      items={items}
                      blockId={currentBlockId}
                      intensityCategoryId={intId}
                      ratingTypeId={rtId}
                      onEmpty={() => {
                        hideAndNotify();
                        // aquí puedes, p.ej., ocultar el panel o cambiar un estado
                      }}
                    />
                  )
                ) : null; // caso para mostrar cuando no exista bloque activo o ranking
              }),
            )}
          </>
        )}
      </>
    </div>
  );
};

export default React.memo(BlockPanel3);
